export default {
  title: "Area Income Range",
  client: "Client",
  areaType: "Area Type",
  count: "Count",
  price: "Price",
  create: "Create",
  form: {
    tenantIsRequired: "Please select a tenant",
    typeIsRequired: "Please select a type",
    countIsRequired: "Please enter a count",
    amountIsRequired: "Please enter an amount",
  },
};
